import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MoonIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="currentColor"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M29.4108 16.5074C29.1944 16.3234 28.9322 16.2056 28.6539 16.1674C28.3757 16.1292 28.0926 16.1722 27.8369 16.2915C26.2519 17.0378 24.5287 17.4219 22.7856 17.4174C19.5613 17.4134 16.4692 16.0978 14.1837 13.7576C11.8981 11.4173 10.6044 8.24214 10.5846 4.92439C10.5914 3.88459 10.7172 2.84923 10.9593 1.83969C11.0107 1.57061 10.9914 1.2923 10.9035 1.03344C10.8156 0.774571 10.6621 0.54451 10.459 0.366954C10.256 0.189399 10.0105 0.0707719 9.74805 0.0232934C9.48558 -0.024185 9.21555 0.0012026 8.96578 0.0968408C6.616 1.18405 4.57337 2.86807 3.02978 4.99068C1.4862 7.11329 0.492329 9.60483 0.141541 12.2312C-0.209248 14.8576 0.0945599 17.5327 1.02442 20.0051C1.95429 22.4775 3.47968 24.6661 5.45731 26.3653C7.43494 28.0645 9.79988 29.2185 12.33 29.7189C14.8601 30.2193 17.4723 30.0497 19.9212 29.226C22.3701 28.4023 24.5753 26.9515 26.3296 25.01C28.084 23.0685 29.3299 20.6999 29.9504 18.1269C30.0259 17.8323 30.015 17.5212 29.919 17.233C29.8229 16.9448 29.6461 16.6923 29.4108 16.5074Z" />
  </svg>
)
const ForwardRef = forwardRef(MoonIcon)
export { ForwardRef as ReactComponent }
